import React from 'react';

import PayloadFields from './PayloadFields';

export const QueryBasedPayloadFields = (query, itemType) => (componentProps) => {
  return <PayloadFields {...componentProps} query={query} itemType={itemType} />;
};
